import { IconButton } from '@mui/material';
import { DatabaseExportOutline, GridOff } from 'mdi-material-ui';
import { VigoTooltip } from 'src/@vigo/vigo-tooltip';
import useServerExport from '../helpers/useServerExport';

/**
 * Default custom grid toolbar components
 *
 */

/**
 * Renders a reset button for the grid that resets the grid to its default layout.
 *
 * @param resetState - A function that resets the state of the grid to its default layout.
 * @returns A React component that renders a reset button for the grid.
 */
export const GridResetButton = ({ resetState }: { resetState: () => void }) => {
  return (
    <VigoTooltip title="Reset grid to default layout">
      <IconButton onClick={resetState} sx={{ cursor: 'pointer' }}>
        <GridOff />
      </IconButton>
    </VigoTooltip>
  );
};

export const ExportButton = ({ storageKey, filter }: { storageKey: string; filter: string }) => {
  const { handleExport } = useServerExport(storageKey, filter);

  return (
    <VigoTooltip title={'Export to CSV'}>
      <IconButton
        sx={{ cursor: 'pointer', paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 2 }}
        component="label"
        onClick={handleExport}>
        <DatabaseExportOutline />
      </IconButton>
    </VigoTooltip>
  );
};
